import React from "react";
import blogs from "../../../assets/img/default-image.jpg";
import { Link } from "react-router-dom";
import SecondaryHeading from "../Typography/SecondaryHeading";
import Paragraph from "../Typography/Paragraph";
import ButtonText from "../Typography/ButtonText";

const BlogCard = ({
  text,
  blogName,
  link,
  imageToTitleClassName = "mt-5",
  titleToBodyClassName = "mt-3",
  bodyToLinkClassName = "mt-4",
}) => {
  return (
    <>
      <div className={"w-full relative"}>
        <Link
          to={"/blogs/article-id-will-be-here"}
        >
        <img
          className="cursor-pointer object-cover object-center w-full h-[420px] sm:h-[400px] md:max-h-[550px] lg:h-[400px] xl:h-[550px] 2xl:h-[600px] rounded-xl"
          src={blogs}
          alt="product images"
        />
        </Link>
        <div className="text-offblack bg-transparent">
          <SecondaryHeading variant={"MainParagraphHeading"} className={`${imageToTitleClassName} font-semibold`}>
            {blogName}
          </SecondaryHeading>
          <Paragraph
            variant={"MainParagraph"}
            className={`h-auto overflow-hidden text-ellipsis ${titleToBodyClassName}`}
          >
            {text}
          </Paragraph>
          <Link
            to={"/blogs/article-id-will-be-here"}
            // to={link}
          >
            <div class={`group relative cursor-pointer w-[77px] lg:w-[78px] ${bodyToLinkClassName}`}>
              <ButtonText variant={"SecondaryText"} className={"-mb-5 group-hover:text-primaryblue"}>
                Read more
              </ButtonText>
              {/* <span class="absolute -bottom-[2px] left-0 w-0 border-b-2 border-primaryblue transition-all duration-100 group-hover:w-[68px] lg:group-hover:w-[71px] xl:group-hover:w-[72px] 2xl:group-hover:w-[75px]" /> */}
                
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default BlogCard;
